


























import { Component, Vue, Watch } from "vue-property-decorator";
import BaseModal from "@/resources/components/BaseModal.vue";
import LoadingOverlay from "@/resources/components/LoadingOverlay.vue";
import MultiSelect from "@/resources/components/MultiSelect.vue";
import QuestionButtons from "@/resources/components/QuestionButtons.vue";
import Division from "@/app/models/Division";

@Component({
    components: {
        QuestionButtons,
        MultiSelect,
        "base-modal"     : BaseModal,
        "loading-overlay": LoadingOverlay,
    },
})
export default class CreateOrEdit extends Vue {
    division: Division = new Division({
        name        : '',
        stationCount: 0,
    });

    submit() {
        this.task(async () => await this.division.save())
            .then(() => this.close());
    }

    close() {
        // @ts-ignore
        this.$parent.reset();
        this.$router.push(this.$route.matched.slice(-2)[0])
    }
}
